import { ErrorBox as EhrBox } from "@metriport/shared-internal";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

export function getAuthUrl(): string {
  return process.env.REACT_APP_ECW_AUTHORIZE_URL!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}
export function getClientId(): string {
  return process.env.REACT_APP_ECW_CLIENT_ID!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}
export function getRedirectUri(): string {
  return process.env.REACT_APP_ECW_REDIRECT_URI!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}

export default function LaunchPage() {
  const location = useLocation();
  const inputParams = new URLSearchParams(location.search);
  const iss = inputParams.get("iss");
  const launch = inputParams.get("launch");
  const [codeVerifier, setCodeVerifier] = useState<string | undefined>(undefined);
  const [codeChallenge, setCodeChallenge] = useState<string | undefined>(undefined);

  function base64urlEncode(str: string): string {
    return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  async function generateCodeVerifierAndHash() {
    const codeVerifier = `${uuidv4()}-${uuidv4()}`;
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashB64 = btoa(String.fromCharCode(...hashArray));
    setCodeVerifier(codeVerifier);
    setCodeChallenge(base64urlEncode(hashB64));
  }

  function callRedirect(redirectUrl: string) {
    window.location.replace(redirectUrl);
  }

  useEffect(() => {
    async function createCodeChallenge() {
      await generateCodeVerifierAndHash();
    }
    createCodeChallenge();
  }, []);

  useEffect(() => {
    if (codeChallenge && codeVerifier) {
      const redirectParams = new URLSearchParams();
      redirectParams.append("response_type", "code");
      redirectParams.append("scope", "launch openid profile fhirUser user/Patient.read");
      redirectParams.append("client_id", getClientId());
      redirectParams.append("redirect_uri", getRedirectUri());
      redirectParams.append("aud", iss ?? "temp");
      redirectParams.append("state", codeVerifier);
      redirectParams.append("launch", launch ?? "temp");
      redirectParams.append("code_challenge_method", "S256");
      redirectParams.append("code_challenge", codeChallenge);
      const redirectUrl = `${getAuthUrl()}?${redirectParams.toString()}`;

      callRedirect(redirectUrl);
    }
  }, [codeChallenge, codeVerifier]);

  return <EhrBox>Launching...</EhrBox>;
}
